import { useCallback, useState } from 'react';

import { formatSecondsToTime, parseTimeToSeconds } from '@helpers';
import type { UseManageTimeEditParams } from '@v2/components/FinishJobModal/types';

const useManageTimeEdit = ({ onActualChange }: UseManageTimeEditParams) => {
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [editValue, setEditValue] = useState('');

  const handleEditBlur = useCallback(() => {
    if (editValue) {
      const seconds = parseTimeToSeconds(editValue);
      onActualChange(seconds);
    }
    setEditingIndex(null);
  }, [editValue, onActualChange]);

  const startEditing = useCallback((index: number, currentSeconds: number) => {
    setEditValue(formatSecondsToTime(currentSeconds));
    setEditingIndex(index);
  }, []);

  return { editingIndex, editValue, setEditValue, handleEditBlur, startEditing };
};

export default useManageTimeEdit;
